import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup, Tooltip } from 'react-leaflet';
import L from 'leaflet'; 
import 'leaflet/dist/leaflet.css';
import locationimg from "../../assets/Location-500-x-500.png" 
import axios from 'axios';
import "./laturmap.scss"
import { IoCloseCircleSharp } from "react-icons/io5";
import Accordian from './accordian/Accordian';




const LaturVillages = [
  { id: 1, village_name: 'देवणी शहर', lat: 18.265360142900636, lng: 77.0815587340124,},
  { id: 2, village_name: 'नेकनाळ', lat: 18.27399544825887, lng: 77.02874339459812,  },
  { id: 3, village_name: 'गुरनाळ', lat: 18.20752814949216, lng: 77.07342390124045, },
  { id: 4, village_name: 'लासोना', lat: 18.17122243422884, lng: 77.0721886522252, },
  { id: 5, village_name: 'देवणी खु', lat: 18.23224359040807, lng: 77.07629779547578, },
  { id: 6, village_name: 'सय्यदपुर', lat: 18.290077241206454, lng: 76.93542364304805, },
  { id: 7, village_name: 'चवणहिप्‍परगा', lat: 18.29180225535631, lng: 76.96854940906645, },
  { id: 8, village_name: 'नागतिर्थवाडी', lat: 18.27923167703368, lng: 76.96682551013934, },
  { id: 9, village_name: 'वलांडी', lat: 18.23408973062249, lng: 76.96316596761334, },
  { id: 10, village_name: 'इंद्राळ', lat: 18.192451685047548, lng: 77.04740709417901, },
  { id: 11, village_name: 'वडमुरंबी', lat: 18.198289714990437, lng: 77.02360290550845,},
  { id: 12, village_name: 'आनंदवाडी', lat: 18.168171419355062,   lng:77.01496789527435,},
  { id: 13, village_name: 'बोळेगाव', lat: 18.1927034730174,  lng: 77.0014212521683,  }, 
  { id: 14, village_name: 'हेळंब', lat: 18.21445229368637, lng: 76.9084274298106,  },
  { id: 15, village_name: 'धनेगाव', lat: 18.200202491481686, lng: 76.91649389734344, },
  { id: 16, village_name: 'दवणहिप्‍परगा', lat: 18.22533023009198, lng: 77.00613673217316, },
  { id: 17, village_name: 'तळेगाव भो', lat: 18.325655254316846, lng: 76.88677428036009, },
  { id: 18, village_name: 'औराद शहा', lat: 18.05474984535763, lng: 76.92750261672323,  },
  { id: 19, village_name: 'शेळगी', lat: 18.031143810611752, lng: 76.90011666446772,  },
  { id: 20, village_name: 'मानेजवळगा', lat: 18.041430570125573, lng: 76.87779012279903,  },
  { id: 21, village_name: 'ताडमुगळी', lat: 18.00738784586143, lng: 76.87762433648227,  },
  { id: 22, village_name: 'तुपडी', lat: 18.240479462852022, lng: 76.68391448730016, },
  { id: 23, village_name: 'शिवणी को', lat: 18.36178654505909, lng: 76.67854624794163,  },
  { id: 24, village_name: 'वडगाव', lat: 18.20725259481474,  lng: 76.70074473613268, },
  { id: 25, village_name: 'हाडगा', lat: 18.194378346885642, lng: 76.7275086883928,  },
  { id: 26, village_name: 'उमरगा हा', lat: 18.170485492724914, lng: 76.7284719703238, },
  { id: 27, village_name: 'शिरूरअनंतपाळ शहर', lat: 18.338552179865687,  lng: 76.83808919403702, },
  { id: 28, village_name: 'चांभरगा', lat: 18.40390193315784, lng: 76.86342479328745,  },
  { id: 29, village_name: 'नागेवाडी', lat: 18.328286442333297,   lng:  76.85165044238768, },
  { id: 30, village_name: 'कारेवाडी', lat: 18.379431707892014,   lng: 76.84629034874803, },
  { id: 31, village_name: 'येरोळ', lat: 18.368109893793402, lng: 76.87799524593238,  },
  { id: 32, village_name: 'पांढरवाडी', lat: 18.335148403566695, lng:  76.87282847595529,  },
  { id: 33, village_name: 'ढोबळेवाडी', lat: 18.26447167355411,   lng: 76.79837683072805,  },
  { id: 34, village_name: 'निटुर', lat: 18.240485815132725,   lng:76.77406831630955,  },
  { id: 35, village_name: 'शेंद', lat: 18.275142486815824,  lng: 76.76032037162587, },
  { id: 36, village_name: 'ताजपुर', lat: 18.24028988181378,  lng:76.75586371217358, },
  { id: 37, village_name: 'मसलगा', lat: 18.252976943933565,  lng:76.72682010607977,  },
  { id: 38, village_name: 'मुगाव', lat: 18.266334370807428,   lng: 76.74507682841377,  },
  { id: 39, village_name: 'गौर', lat: 18.263746353678812,  lng: 76.69196573917077,  },
  { id: 40, village_name: 'आनंदवाडी गौर', lat: 18.265897954321723, lng:  76.70898363921867, },
  { id: 41, village_name: 'अंबुलगा बु', lat: 18.284589245718774,  lng:  76.65601718804857, },
  { id: 42, village_name: 'शिऊर', lat: 18.323111654466302,   lng: 76.45195467279781, },
  { id: 43, village_name: 'आनंदवाडी अ.बु', lat: 18.286378908692843,  lng: 76.6561010523672, },
  { id: 44, village_name: 'बोटकुळ', lat: 18.138272522609714,  lng: 76.8865519995758,  },
  { id: 45, village_name: 'माकणी थोर', lat: 18.08863885054578,  lng:  76.839729558839,  },
  { id: 46, village_name: 'अंकुलगा स', lat: 18.246968789011056,  lng: 76.85187041654167, },
  { id: 47, village_name: 'तळेगाव दे', lat: 18.271913128835024,  lng: 77.00448962270262,  },
  { id: 48, village_name: 'तिपराळ', lat: 18.30237496677722,  lng: 76.89808484516816,  },
  { id: 49, village_name: 'कानेगाव', lat: 18.309790281885288,  lng:76.93293210358821,  },
  { id: 50, village_name: 'साकोळ', lat: 18.285505979901423,  lng: 76.88735600944769, },
  { id: 51, village_name: 'हिसामाबाद (उजेड)', lat: 18.27511051530358,  lng: 76.80530369265179, },
  { id: 52, village_name: 'भिंगोली', lat: 18.318617502377805,  lng: 76.80542822998135,  },
  { id: 53, village_name: 'हालसी तू', lat: 18.104939369463825, lng:  76.93427398231768,  },
  { id: 54, village_name: 'तांबरवाडी', lat: 18.110405219368317, lng:  76.90294578114577,  },
  { id: 55, village_name: 'हलगरा', lat: 18.083162701321687,  lng: 76.84704479460545,  },
  { id: 56, village_name: 'हनमंतवाडी ह', lat: 18.00775620950751,  lng: 76.7161444996642,  },
  { id: 57, village_name: 'हनमंतवाडी अं बु', lat: 18.12687553831335, lng:  76.6951961634873,  },
  { id: 58, village_name: 'सावरी', lat: 18.052166586946214,  lng:76.85529865510057,  },
  { id: 59, village_name: 'कोयाचीवाडी', lat: 18.07924373764692,  lng: 76.86419708265065,  },
  { id: 60, village_name: 'तगरखेडा', lat: 18.078971344136026, lng:  76.91424379592164, },

];


const redPointer = new L.Icon({
  iconUrl: locationimg, 
  iconSize: [41, 41],
  iconAnchor: [20, 41], 
  popupAnchor: [0, -41], 
});

const LaturMap = () => {
  const [selectedVillage, setSelectedVillage] = useState(null);

 
  // const handleMarkerClick = (village) => {
  //   setSelectedVillage(village);
  // };

  
  const laturBounds = [
    // [18.1262, 75.5000], // Southwest corner of Latur
    // [18.4700, 76.7510], // Northeast corner of Latur
  ];


  const villageDataByName = async (village_name) => {
    try {
      const response = await axios.get(`https://backend.sambhajipatilnilangekar.com/api/lekhajokha/getVillageDatabyVillageName?village_name=${village_name}`);
     
      setSelectedVillage(response.data.response)
    } catch (error) {
      console.log(error)
    }
  };


  const [popUp, setPopUp] = useState(false);

  function openPop (village_name) {
    setPopUp(true);
    villageDataByName(village_name);
  }

  function closePop () {
    setPopUp(false);
  }







  return (
    <div className="map-parent parent">
      <div className="map-container">
        <MapContainer
          center={[18.12623852790791, 76.75492644179782]} 
          zoom={12} 
          style={{ width: '100%', height: '500px' }}
          scrollWheelZoom={false}
          bounds={laturBounds} 
          maxBounds={laturBounds} 
          maxZoom={18}
          minZoom={8} 
        >
          
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

          {/* Add markers for each village */}
          {LaturVillages.map((village) => (
            <Marker
              key={village.id}
              position={[village.lat, village.lng]}
              icon={redPointer}
              eventHandlers={{
                // click: () => {villageDataByName(village.village_name)}
                click: () => {openPop(village.village_name)}
              }}
            >

              <Tooltip permanent>{village.village_name}</Tooltip>
            </Marker>
          ))}
        </MapContainer>

        {/* popup */}




        {popUp &&
          <div className="overlay">
            <div className="pop_card">

              <div className="close" onClick={closePop}>
              <IoCloseCircleSharp />
              </div>


             {
              selectedVillage && selectedVillage.slice(0, 1).map((item, index)=>(
                <h2>  <span> {item.village_name}  </span>येथे झालेली विकासकामे</h2>
              ))
             }


              <Accordian  selectedVillage={selectedVillage}/>

              
              


            </div>
          </div>}








        {/* Display information about the selected village */}



        {/* <div className="village-info cont">
          {selectedVillage && selectedVillage.map((item, index) => (
            <div className="work-detail">
              <h3>
               { item.work_desc}
              </h3>

              <p>
              {  item.start_date}
              </p>
            </div>
          ))

          }

        </div> */}


      </div>
    </div>
  );
};

export default LaturMap;
